<template>
  <div class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <h2>ท่านต้องการแลกของรางวัลหรือไม่</h2>
      <p>หลังจากกดยืนยันแล้ว<br/>ท่านจะไม่สามารถแก้ไขได้</p>
      <div class="button-group">
        <button class="btn btn-pink" @click="closeModal" :disabled="submitting">
          สะสมต่อไป
        </button>
        <button
          v-for="reward in rewards"
          :key="reward.id || reward.name"
          class="btn"
          :class="{
            'btn-outline-pink': availablePoints >= reward.cost,
            'btn-gray': availablePoints < reward.cost,
          }"
          :disabled="submitting || availablePoints < reward.cost"
          @click="sendMessage(reward)"
        >
          <span class="reward-btn-label">
            {{ reward.boxLabel }}<br />
            {{ reward.redeemLabel }}<br />
            ({{ reward.quantityLabel }})
          </span>
        </button>
       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RewardModal',
  props: {
    availablePoints: {
      type: Number,
      required: true,
    },
    rewards: {
      type: Array,
      default: () => [],
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    sendMessage(reward) {
      if (this.submitting) return;
      this.$emit('submit', reward);
    },
    closeModal() {
      if (this.submitting) return;
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
  width: 90%;
}

h2 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

p {
  margin-bottom: 1.5rem;
  color: #6c757d;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.btn {
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  width: 100%;
  white-space: pre-line;
}

.btn-pink {
  background-color: #ff8ab4; /* A pink shade */
  color: white;
}

.btn-light-gray {
  background-color: #e9ecef;
  color: #495057;
}

.btn-gray {
  background-color: #ced4da;
  color: #6c757d;
  cursor: not-allowed;
}

.btn-outline-pink {
  background-color: white;
  color: #ff8ab4;
  border: 1px solid #ff8ab4;
}

.btn:disabled {
    opacity: 0.7;
}
</style> 